import { render, staticRenderFns } from "./index.vue?vue&type=template&id=401c2d6b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../style.scss?vue&type=style&index=0&id=401c2d6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401c2d6b",
  null
  
)

export default component.exports